// src/services/apiMiddleware.js
import axios from "axios";

// Create axios instance with base config
const apiMiddleware = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || "http://127.0.0.1:8000") + "/api", // your API base URL
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 300000, // 5 minutes timeout
});

// Request interceptor to add auth token if exists
apiMiddleware.interceptors.request.use(
  (config) => {
    // Backward-compat: allow old keys if present
    const token = localStorage.getItem("admin_token") || localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers.Accept = "application/json";
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for global error handling
apiMiddleware.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can handle specific error statuses globally here
    if (error.response) {
      if (error.response.status === 401) {
        // Only redirect if not already on login page
        const currentPath = window.location.pathname;
        if (currentPath !== "/login" && !currentPath.includes("/login")) {
          localStorage.removeItem("admin_token");
          localStorage.removeItem("admin_user");
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiMiddleware;
